import { MEDALLION_PREVIEW_SCREENS } from '../helper/constants';
import BankConnectScreen from './BankConnectScreen';
import ConsentScreen from './ConsentScreen';
import GovtIdCaptureScreen from './GovtIdCaptureScreen';
import KbaQuizScreen from './KbaQuizScreen';
import ThankYouScreen from './ThankYouScreen';
import TwoFactorScreen from './TwoFactorScreen';
import VerificationScreen from './VerificationScreen';

export const SCREEN_COMPONENTS = {
    [MEDALLION_PREVIEW_SCREENS.CONSENT_SCREEN]: ConsentScreen,
    [MEDALLION_PREVIEW_SCREENS.TWO_FACTOR_SCREEN]: TwoFactorScreen,
    [MEDALLION_PREVIEW_SCREENS.VERIFICATION_SCREEN]: VerificationScreen,
    [MEDALLION_PREVIEW_SCREENS.GOVT_ID_CAPTURE_SCREEN]: GovtIdCaptureScreen,
    [MEDALLION_PREVIEW_SCREENS.KBA_QUIZ_SCREEN]: KbaQuizScreen,
    [MEDALLION_PREVIEW_SCREENS.BANK_CONNECT_SCREEN]: BankConnectScreen,
    [MEDALLION_PREVIEW_SCREENS.THANK_YOU_SCREEN]: ThankYouScreen,
};
